import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import type {
  CreateConselhoSuperiorDto,
  ReadConselhoSuperiorBienioDto,
  ReadConselhoSuperiorDto,
  UpdateConselhoSuperiorDto,
} from '@/api.types';

const endpoint = Endpoints.CONSELHO_SUPERIOR;

export async function getConselhoSuperiorAtual(): Promise<ReadConselhoSuperiorDto> {
  try {
    const response = await api.get<ReadConselhoSuperiorDto>(`${endpoint}/atual`);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao carregar o Conselho Superior do biênio atual.');
  }
}

export async function getConselhoSuperiorPorBienio(anoInicio: number): Promise<ReadConselhoSuperiorDto> {
  try {
    const response = await api.get<ReadConselhoSuperiorDto>(endpoint, {
      params: { anoInicio },
    });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao carregar o Conselho Superior do biênio.');
  }
}

export async function listConselhoSuperiorBienios(): Promise<ReadConselhoSuperiorBienioDto[]> {
  try {
    const response = await api.get<ReadConselhoSuperiorBienioDto[]>(`${endpoint}/bienios`);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao listar biênios do Conselho Superior.');
  }
}

export async function createConselhoSuperior(
  dto: CreateConselhoSuperiorDto,
): Promise<ReadConselhoSuperiorDto> {
  try {
    const response = await api.post<ReadConselhoSuperiorDto>(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar o Conselho Superior.');
  }
}

export async function updateConselhoSuperior(
  id: number,
  dto: UpdateConselhoSuperiorDto,
): Promise<ReadConselhoSuperiorDto> {
  try {
    const response = await api.put<ReadConselhoSuperiorDto>(`${endpoint}/${id}`, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao salvar o Conselho Superior.');
  }
}
